import React, { useState } from 'react';
// import Truncate from 'react-truncate';

const TextWithHint = ({ text, line }) => {
  const [isShow, setShow] = useState(false);

  return (
    <span
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {/* <Truncate
        lines={line}
        ellipsis='...'
        onTruncate={ (e) => console.log(e) }
      >
        { text }
      </Truncate>

      {isShow && <span >
        { text }
      </span>} */}
      {text}
    </span>
  );
};

export default TextWithHint;